export const TOKEN = 'token';
export const REFRESH_TOKEN = 'refreshToken';
export const USER_ROLES = 'roles';
